<div class="redaction-flow-container">
    <!-- Header -->
    <div class="flow-header">
        <div class="header-info">
            <h2>
                <mat-icon>rate_review</mat-icon>
                CIRCUIT REDACTARE - DOCUMENT GENERAT
            </h2>
            <div class="document-info">
                <div class="info-row" *ngIf="data.templateName">
                    <mat-icon>description</mat-icon>
                    <span class="label">Template:</span>
                    <span class="value">{{ data.templateName }}</span>
                </div>
                <div class="info-row">
                    <mat-icon>tag</mat-icon>
                    <span class="label">ID Document:</span>
                    <span class="value">#{{ data.documentGeneratId }}</span>
                </div>
            </div>
        </div>
        <div class="header-actions">
            <button mat-icon-button class="close-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Status Badge Row -->
    <div class="status-row" *ngIf="flowData">
        <span class="status-badge" [ngClass]="'step-' + flowData.redaction_step">
            <mat-icon>{{ isRedactionComplete ? 'check_circle' : (isRedactionInProgress ? 'pending' : 'schedule') }}</mat-icon>
            {{ flowData.redaction_step_text }}
        </span>
        <span class="progress-info">
            {{ flowData.completed_steps }} / {{ flowData.total_steps }} pasi finalizati
        </span>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
        <mat-spinner diameter="48"></mat-spinner>
        <p>Se incarca circuitul de redactare...</p>
    </div>

    <!-- Error State -->
    <div class="error-state" *ngIf="errorMessage && !isLoading">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h3>{{ errorMessage }}</h3>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && !errorMessage && !hasRedactions">
        <mat-icon class="empty-icon">assignment_late</mat-icon>
        <h3>Nu exista circuit de redactare</h3>
        <p>Acest document nu are pasi de redactare configurati.</p>
    </div>

    <!-- Flow Content -->
    <div class="flow-content-wrapper" *ngIf="!isLoading && !errorMessage && hasRedactions">
        <div class="flow-column">
            <!-- Processed Section -->
            <div class="flow-section processed-section" *ngIf="getProcessedRedactions().length > 0">
                <div class="section-header">
                    <mat-icon>history</mat-icon>
                    <span>Pasi Procesati</span>
                </div>

                <ng-container *ngFor="let node of getProcessedRedactions(); let i = index; let last = last">
                    <div class="flow-node redaction-node" [ngClass]="[getTypeClass(node.redaction_type), getStatusClass(node.type)]">
                        <div class="node-order">{{ node.order }}</div>
                        <div class="node-content">
                            <div class="node-header">
                                <mat-icon>{{ getTypeIcon(node.redaction_type) }}</mat-icon>
                                <span class="functie-name">{{ node.functie_name || 'Pas redactare' }}</span>
                            </div>
                            <div class="node-badges">
                                <span class="type-badge" [ngClass]="getTypeClass(node.redaction_type)">
                                    {{ getTypeLabel(node.redaction_type) }}
                                </span>
                                <span class="status-badge" [ngClass]="getStatusClass(node.type)">
                                    <mat-icon>{{ getStatusIcon(node.type) }}</mat-icon>
                                    {{ getStatusLabel(node.type) }}
                                </span>
                            </div>
                            <div class="node-details" *ngIf="node.user_name || node.action_date || node.observations">
                                <div *ngIf="node.directie_name" class="detail-row">
                                    <mat-icon>business</mat-icon>
                                    <span>{{ node.directie_name }}</span>
                                </div>
                                <div *ngIf="node.compartiment_name" class="detail-row">
                                    <mat-icon>folder</mat-icon>
                                    <span>{{ node.compartiment_name }}</span>
                                </div>
                                <div *ngIf="node.user_name" class="detail-row user-assigned">
                                    <mat-icon>person</mat-icon>
                                    <span>{{ node.user_name }}</span>
                                </div>
                                <div *ngIf="node.action_date" class="detail-row action-date">
                                    <mat-icon>event</mat-icon>
                                    <span>{{ formatDate(node.action_date) }}</span>
                                </div>
                                <div *ngIf="node.observations" class="detail-row observations">
                                    <mat-icon>notes</mat-icon>
                                    <span>{{ node.observations }}</span>
                                </div>
                                <div *ngIf="node.file_uploaded" class="detail-row file-info">
                                    <mat-icon>attach_file</mat-icon>
                                    <span>Versiune uploadata</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flow-connector" *ngIf="!last || getPendingRedactions().length > 0">
                        <div class="connector-line"></div>
                        <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                    </div>
                </ng-container>
            </div>

            <!-- Pending Section -->
            <div class="flow-section pending-section" *ngIf="getPendingRedactions().length > 0">
                <div class="section-header">
                    <mat-icon>pending_actions</mat-icon>
                    <span>Pasi in Asteptare</span>
                </div>

                <div class="pending-list">
                    <ng-container *ngFor="let node of getPendingRedactions(); let i = index; let first = first; let last = last">
                        <div
                            class="flow-node redaction-node pending-node"
                            [ngClass]="{ 'current-step': isCurrentStep(node) }"
                        >
                            <div class="node-order">{{ node.order }}</div>
                            <div class="node-content">
                                <div class="node-header">
                                    <mat-icon>{{ getTypeIcon(node.redaction_type) }}</mat-icon>
                                    <span class="functie-name">{{ node.functie_name || 'Pas redactare' }}</span>
                                    <span class="current-badge" *ngIf="isCurrentStep(node)">
                                        <mat-icon>play_arrow</mat-icon> Pasul curent
                                    </span>
                                </div>
                                <div class="node-badges">
                                    <span class="type-badge" [ngClass]="getTypeClass(node.redaction_type)">
                                        {{ getTypeLabel(node.redaction_type) }}
                                    </span>
                                    <span class="status-badge status-pending">
                                        <mat-icon>schedule</mat-icon>
                                        In asteptare
                                    </span>
                                </div>
                                <div class="node-details">
                                    <div *ngIf="node.directie_name" class="detail-row">
                                        <mat-icon>business</mat-icon>
                                        <span>{{ node.directie_name }}</span>
                                    </div>
                                    <div *ngIf="node.compartiment_name" class="detail-row">
                                        <mat-icon>folder</mat-icon>
                                        <span>{{ node.compartiment_name }}</span>
                                    </div>
                                    <div *ngIf="node.specific_user_name" class="detail-row user-assigned">
                                        <mat-icon>person</mat-icon>
                                        <span>{{ node.specific_user_name }}</span>
                                        <span class="user-badge">Operator Specific</span>
                                    </div>
                                    <!-- Indicator dacă userul curent e alocat pe acest pas -->
                                    <div *ngIf="isCurrentStep(node) && isUserAssignedToNode(node)" class="detail-row my-turn">
                                        <mat-icon>how_to_reg</mat-icon>
                                        <span class="my-turn-badge">Este randul tau!</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flow-connector" *ngIf="!last">
                            <div class="connector-line"></div>
                            <mat-icon class="connector-arrow">arrow_downward</mat-icon>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- End Node -->
            <div class="flow-connector" *ngIf="hasRedactions">
                <div class="connector-line"></div>
                <mat-icon class="connector-arrow">arrow_downward</mat-icon>
            </div>

            <div class="flow-node end-node" [ngClass]="{'completed': isRedactionComplete}">
                <div class="node-icon">
                    <mat-icon>{{ isRedactionComplete ? 'verified' : 'flag' }}</mat-icon>
                </div>
                <div class="node-content">
                    <span class="node-title">{{ isRedactionComplete ? 'REDACTARE FINALIZATA' : 'FINALIZARE REDACTARE' }}</span>
                    <span class="node-subtitle">{{ isRedactionComplete ? 'Documentul trece la circuitul de semnare' : 'Dupa toti pasii, documentul va trece la semnare' }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="flow-footer">
        <div class="footer-left">
            <button mat-raised-button color="primary" class="export-btn" (click)="exportToPdf()" [disabled]="isExporting || isLoading || !hasRedactions">
                <mat-icon *ngIf="!isExporting">picture_as_pdf</mat-icon>
                <mat-spinner *ngIf="isExporting" diameter="20"></mat-spinner>
                <span>{{ isExporting ? 'Export...' : 'Export PDF' }}</span>
            </button>
        </div>
        <div class="footer-right">
            <button mat-raised-button (click)="closeDialog()">
                <mat-icon>close</mat-icon>
                Inchide
            </button>
        </div>
    </div>

    <!-- Legend -->
    <div class="flow-legend" *ngIf="!isLoading && !errorMessage && hasRedactions">
        <span class="legend-title">Tip redactare:</span>
        <div class="legend-item redaction-type-edit">
            <mat-icon>edit_document</mat-icon> Editare + Upload
        </div>
        <div class="legend-item redaction-type-review">
            <mat-icon>fact_check</mat-icon> Review/Aprobare
        </div>
        <span class="legend-separator">|</span>
        <span class="legend-title">Status:</span>
        <div class="legend-item status-pending">
            <mat-icon>schedule</mat-icon> In asteptare
        </div>
        <div class="legend-item status-done">
            <mat-icon>check_circle</mat-icon> Finalizat
        </div>
        <div class="legend-item status-rejected">
            <mat-icon>cancel</mat-icon> Respins
        </div>
        <div class="legend-item status-skipped">
            <mat-icon>skip_next</mat-icon> Sarit
        </div>
    </div>
</div>
